class CancellationTokenHook {
    token;
    constructor(params) {
        this.token = params.token;
    }
    onRequest(req) {
        if (this.token) {
            if (this.token.isCanceled()) {
                throw this.token.reason;
            }
            this.token.toPromise().then(reason => {
                if (reason) {
                    req.destroy(reason);
                }
            });
        }
    }
    onResponse() {
        if (this.token && !this.token.isCanceled()) {
            this.token.destroy();
        }
    }
    onError() {
        if (this.token && !this.token.isCanceled()) {
            this.token.destroy();
        }
    }
}

export { CancellationTokenHook };
//# sourceMappingURL=CancellationTokenHook.mjs.map
